import { noop } from 'lodash'

import { createComponentContext } from '@hooks'
import { CriteriaType } from '@constants'
import { GETSearchType } from '@types'

type SearchAssistantContextType = {
  entityInternalId?: string
  searchAssistantId?: string | number
  isInDialogWindow?: boolean
  entityObjectCode?: string
  isDropDownWindowOpen: boolean
  // isSearchAssistantDialogWindow: boolean
  entityCode?: string
  entityId?: string | number
  editable?: boolean
  onChangeDropDownWindowOpen: (value: boolean) => void
  onSearchFilter: (criterieas: CriteriaType[]) => void
  // loadingContextSA?: boolean
  // assistantCriterias?: CriteriaType[]
  // favouriteSearchDefault?: GETSearchType | undefined
  // setSelectedFavourite: (value: GETSearchType | undefined) => void
  selectedFavourite?: GETSearchType | null
}

const [SearchAssistantProvider, useSearchAssistantContext] =
  createComponentContext<SearchAssistantContextType>('SearchAssistant', {
    onSearchFilter: noop,
    isDropDownWindowOpen: false,
    onChangeDropDownWindowOpen: noop,
  })

export { SearchAssistantProvider, useSearchAssistantContext }
export type { SearchAssistantContextType }
